/**
 * Default scrollbar width used across the application.
 */
export const SCROLLBAR_WIDTH_PX = 5;
